import PaymentDialogRightContent from './PaymentDialogRightContent'

export * from './PaymentDialogRightContent'
export default PaymentDialogRightContent
